import { Condition } from './condition.model';

export class Action {
    Name: string;
    Conditions: Condition[];
}
